import { render, staticRenderFns } from "./HsaBankInvestmentsFooter.vue?vue&type=template&id=01eaaeb9&scoped=true"
import script from "./HsaBankInvestmentsFooter.vue?vue&type=script&lang=ts"
export * from "./HsaBankInvestmentsFooter.vue?vue&type=script&lang=ts"
import style0 from "./HsaBankInvestmentsFooter.vue?vue&type=style&index=0&id=01eaaeb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01eaaeb9",
  null
  
)

export default component.exports